import { COLORS } from '@/constants';
import { Button } from '@mui/material';
import styled from 'styled-components';

export const RowBox = styled.div<{ $gap?: number; $mobileColumn?: boolean }>`
  display: flex;
  gap: ${(props) => (props.$gap ? props.$gap : 18)}px;
  @media (max-width: 830px) {
    flex-wrap: wrap;
  }
  @media (max-width: 600px) {
    ${(props) =>
      props.$mobileColumn &&
      `
      flex-direction: column;
      gap: 8px;
    `}
  }
`;

export const OfferTypeRow = styled.div`
  display: flex;
  gap: 8px;

  @media (max-width: 600px) {
    width: 100%;
    gap: 8px;
  }
`;

export const StyledButton = styled(Button)<{ $isActive: boolean }>`
  && {
    background-color: ${(props) => (props.$isActive ? COLORS['secondary/50'] : COLORS.white)};
    border: 2px solid ${(props) => (props.$isActive ? COLORS.orange : COLORS['neutral/300'])} !important;
    border-radius: 6px;
    position: relative;
    color: ${(props) => (props.$isActive ? COLORS['blue-dark'] : COLORS.gray)};
    path {
      fill: ${(props) => (props.$isActive ? COLORS.orange : '#737373')};
    }
    height: 40px;
    padding: 11px 20px 11px 12px !important;
  }
`;

export const MobileFilterButton = styled(Button)`
  && {
    display: none;
    min-width: 44px !important;
    width: 44px !important;
    height: 40px !important;
    padding: 0 !important;
    border: 1px solid ${COLORS['neutral/500']} !important;
    border-radius: 6px !important;
    color: ${COLORS['secondary/500']} !important;
    background: ${COLORS.white} !important;
    flex-shrink: 0;

    @media (max-width: 800px) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const MobileSearchRow = styled.div`
  display: none;

  @media (max-width: 800px) {
    display: flex;
    gap: 8px;
    align-items: center;
    width: 100%;
  }
`;

export const StyledSubmitButton = styled(Button)<{
  $color: keyof typeof COLORS;
  $bgColor: keyof typeof COLORS;
}>`
  height: 50px !important;
  padding: 14px 32px !important;
  border-radius: 6px !important;
  border: none !important;
  color: ${(props) => COLORS[props.$color]} !important;
  background: ${(props) => COLORS[props.$bgColor]} !important;
`;

export const ButtonsBox = styled.div`
  display: flex;
  margin-left: auto;
  gap: 16px;

  button {
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 600px) {
    margin: 40px auto 0;
    width: 240px;
    flex-direction: column;

    button {
      width: 100%;
      height: 48px;
    }
  }
`;

export const HeroBgImageWrap = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

export const HeroWrapper = styled.section`
  position: relative;
  width: 100%;
  height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 800px) {
    height: auto;
    min-height: calc(100vh - 60px);
    align-items: center;
    padding: 32px 0;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(63, 41, 10, 0.34);
    z-index: 3;
  }
`;

export const FiltersContainer = styled.div<{ $fullWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  z-index: 4;
  max-width: ${(props) => (props.$fullWidth ? '100%' : '1200px')};
  width: 100%;

  @media (max-width: 800px) {
    gap: 12px;
  }
`;

export const FilterBox = styled.div`
  padding: 32px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: ${COLORS.white};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);

  @media (max-width: 800px) {
    padding: 16px;
    gap: 12px;
  }
`;

export const InputsBox = styled.div`
  display: flex;
  gap: 16px;
  flex: 1;

  @media (max-width: 800px) {
    flex-wrap: wrap;
    width: 100%;

    & > * {
      flex: 1 1 calc(50% - 8px);
      min-width: 0;
    }
  }

  @media (max-width: 800px) {
    display: none;
  }
`;

export const DesktopSearchField = styled.div`
  flex: 1;
  min-width: 200px;

  @media (max-width: 800px) {
    display: none;
  }
`;
